<template>
  <div class="animated fadeIn kirimanfrm">
    <b-card>
      <div slot="header">
        {{$route.meta.label}}
        <div class="card-header-actions">
          <button v-if="saveEnabled" class="btn btn-primary mr-1" @click.stop="save()">
            <i class="fa fa-save"></i> Save
          </button>
          <b-button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> Close
          </b-button>
        </div>
      </div>
      <b-row>
        <b-col lg="7">
          <b-input-group>
            <b-input-group-prepend>
              <label>Agen/Langganan</label>
            </b-input-group-prepend>
            <b-form-input
              readonly
              v-model="model.CustInfo"
              @keyup.13.native="lkuKoranCustShow=true"
              :state="!$v.model.customer_id.$error"
            ></b-form-input>
            <b-input-group-append>
              <b-btn
                text="Button"
                id="btnKoranCust"
                @click="lkuKoranCustShow=true"
                :disabled="isEdit"
              >
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
            <!-- <b-form-input class="ml-1" v-model="customer.CustName" readonly></b-form-input> -->
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Ditagihkan Kepada</label>
            </b-input-group-prepend>
            <b-form-input
              readonly
              v-model="model.Bill2CustInfo"
              @keyup.13.native="lkuKoranCustShow=true"
              :state="!$v.model.Bill2CustId.$error"
            ></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" id="btnKoranCust" @click="lkuKoranBill2CustShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
            <!-- <b-form-input class="ml-1" v-model="customer.CustName" readonly></b-form-input> -->
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Alamat Penagihan</label>
            </b-input-group-prepend>
            <b-form-input v-model="model.Address1" readonly></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label></label>
            </b-input-group-prepend>
            <b-form-input v-model="model.Address2" readonly class="mt-1"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Alamat Pengiriman</label>
            </b-input-group-prepend>
              <b-form-textarea v-model="model.DeliveryAddr" :state="!$v.model.DeliveryAddr.$error" rows="2" max-rows="5"></b-form-textarea>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Kota/Area Layanan</label>
            </b-input-group-prepend>
            <b-form-input
              readonly
              v-model="model.kota_name"
              @keyup.13.native="lkuKoranKotaShow=true"
              :state="!$v.model.kota_id.$error"
              placeholder="Pilih Kota/Area"
            ></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="lkuKoranKotaShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Sales Executive</label>
            </b-input-group-prepend>
            <b-form-input
              readonly
              v-model="model.salesae_name"
              @keyup.13.native="lkuKoranSalesShow=true"
              placeholder="Pilih Sales Executive"
            ></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" id="btnKoranCust" @click="lkuKoranSalesShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
            <b-input-group-prepend>
              <label class="text-right">Kolektor</label>
            </b-input-group-prepend>
            <b-form-input
              readonly
              v-model="model.collector_name"
              @keyup.13.native="lkuKoranColectorShow=true"
              placeholder="Pilih Kolektor"
            ></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" id="btnKoranCust" @click="lkuKoranColectorShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col lg="5">
          <b-input-group>
            <b-input-group-prepend><label>Tanggal Kirim</label></b-input-group-prepend>
              <b-form-input
                type="date"
                v-model="model.tanggal"
                :state="!$v.model.tanggal.$error"
              ></b-form-input>
              <b-input-group-append><span class="ml-2 p-2">No. faktur</span></b-input-group-append>
              <b-form-input v-model="model.nofaktur" readonly></b-form-input>
          </b-input-group>          
          <b-input-group>
            <b-input-group-prepend>
              <label>Jenis Kiriman</label>
            </b-input-group-prepend>
            <b-form-select
              v-model="model.kiriman_code"
              :options="jeniskiriman"
              class="mb-1"
              :state="!$v.model.kiriman_code.$error"
              @change="changeJnsKiriman"
              :plain="true"
            >
              <template v-slot:first>
                <option :value="null" disabled>-- Please select an option --</option>
              </template>
            </b-form-select>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Rute</label>
            </b-input-group-prepend>
            <b-form-input
              readonly
              v-model="model.jurusan_info"
              @keyup.13.native="lkuKoranJurusanShow=true"
              :state="!$v.model.jurusan_id.$error"
              placeholder="Pilih Jurusan"
            ></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="lkuKoranJurusanShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend><label>Titik Drop</label></b-input-group-prepend>
            <b-form-input v-model="model.titikdrop" placeholder="Drop point"></b-form-input>
          </b-input-group>


          <b-input-group>
            <b-input-group-prepend><label>Jml.kiriman Berbayar</label></b-input-group-prepend>
            <b-form-input v-model="model.eceran" type=number v-b-tooltip.hover :title="model.eceran" :state="!$v.model.eceran.$error" ></b-form-input>
            <b-input-group-prepend><span class="input-group-text">eksemplar</span></b-input-group-prepend>
            <b-input-group-append><span class="ml-2 p-2">Harga Koran</span></b-input-group-append>
            <b-input-group-prepend><span class="input-group-text">{{uanguser}}</span></b-input-group-prepend>
            <v-number
              class="form-control text-right"
              separator=","
              id="hrg_agen_ecer"
              v-model="model.hrg_agen_ecer"
              :state="!$v.model.hrg_agen_ecer.$error"
            ></v-number>          
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label>Total kiriman </label></b-input-group-prepend>
            <b-form-input v-model="model.totkirim" readonly  v-b-tooltip.hover :title="model.totkirim"></b-form-input>
            <b-input-group-prepend><span class="input-group-text">eksemplar</span></b-input-group-prepend>
            <b-input-group-prepend><span class="pl-2 pt-2">Tdk.bayar</span></b-input-group-prepend>
            <b-form-input v-model="model.gratis" :title="model.gratis" disabled></b-form-input>
            <b-input-group-prepend><span class="pl-2 pt-2" v-if="isKORANAGEN">Titipan</span>
                    <span v-else class="input-group-text">eks.</span>
            </b-input-group-prepend>
            <b-form-input v-model="model.titipan" :title="model.titipan" disabled v-if="isKORANAGEN"></b-form-input>
          </b-input-group >


          <b-input-group v-if="!(isKORANAGEN)">
              <b-input-group-prepend>
                <label>Titip Kirim ke</label>
              </b-input-group-prepend>
              <b-form-input
                readonly
                v-model="model.namaAgentDititip"
                :key="model.kirimtitipke"
                ref="inputtitipanagen"
                @keyup.13.native="lkuKoranAgenShow=true"
                placeholder="Pilih Agent"
              ></b-form-input>
              <b-input-group-append>
                <b-btn text="Button" id="btnKoranAgen" @click="lkuKoranAgenShow=true" :disabled="isKORANAGEN">
                  <i class="fa fa-search"></i>
                </b-btn>
                <b-btn text="Button" id="btnKoranAgenCleat" v-on:click="clearTitipanAgen()">
                  <i class="fa fa-close"></i>
                </b-btn>
              </b-input-group-append>
          </b-input-group>

        </b-col>
      </b-row>
            <b-row class="justify-content-center mb-2">
                <b-input-group-prepend><span class="p-2">tetap dlm Form setelah Save</span></b-input-group-prepend>
                  <b-form-checkbox v-model="inputBerlanjut" :value="1" :unchecked-value="0"  class="pt-2"></b-form-checkbox>
                <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close Form</button>
            </b-row>
    </b-card>

    <b-modal
      v-model="lkuKoranCustShow"
      size="lg"
      :hide-footer="true"
      title="List of Customer"
      :centered="true"
    >
      <lku-koran-cust @click="onSelectKoranCust"></lku-koran-cust>
    </b-modal>
    <b-modal
      v-model="lkuKoranAgenShow"
      size="lg"
      :hide-footer="true"
      title="Daftar Agen Koran"
      :centered="true"
    >
      <lku-koran-cust @click="onSelectKoranAgen" :customer_group="koranagngroup"></lku-koran-cust>
    </b-modal>

    <b-modal
      v-model="lkuKoranBill2CustShow"
      size="lg"
      :hide-footer="true"
      title="List of Customer"
      :centered="true"
    >
      <lku-koran-cust @click="onSelectKoranBill2Cust"></lku-koran-cust>
    </b-modal>

    <b-modal
      v-model="lkuKoranJurusanShow"
      size="lg"
      :hide-footer="true"
      title="List of Jurusan/Ekspedisi"
      :centered="true"
    >
      <lku-koran-jurusan @click="onSelectKoranJurusan"></lku-koran-jurusan>
    </b-modal>

    <b-modal
      v-model="lkuKoranKotaShow" size="lg"
      :hide-footer="true"
      title="List of Kota Layanan"
      :centered="true"
    >
      <lku-koran-kota @click="onSelectKoranKota"></lku-koran-kota>
    </b-modal>

    <b-modal
      v-model="lkuKoranSalesShow"
      size="lg"
      :hide-footer="true"
      title="List of Sales"
      :centered="true"
    >
      <lku-salesae @click="onSelectSalese" crudfilter="koran=1"></lku-salesae>
    </b-modal>

    <b-modal
      v-model="lkuKoranColectorShow"
      size="lg"
      :hide-footer="true"
      title="List of Collector"
      :centered="true"
    >
      <lku-collector @click="onSelectCollector"></lku-collector>
    </b-modal>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
  </div>
</template>
<style lang="scss">
  .kirimanfrm {
      table {
        border: none;
        font-size: smaller;
        th {
          border-bottom: 1px solid #d1d1d1;
          padding: 0 15px;
          height: 30px;
          background: #e8e8e8;
        }
      }
  }
</style>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import toastr from "mini-toastr";
import vNumber from "vue-numeric";
import Loading from "vue-loading-overlay";
import 'vue-loading-overlay/dist/vue-loading.css';
import crud from "../../apis/crud";
// import customer from "../../apis/customer";
// import koran_pesanan_permanen from "../../apis/koran_pesanan_permanen";
import koran_kiriman from "../../apis/koran_kirim_pesanan";
import lkuKoranCust from "../lookup/lkuKoranCustomer";
import lkuKoranJurusan from "../lookup/lkuKoranJurusan";
import lkuKoranKota from "../lookup/lkuKoranKota";
import lkuSalesae from "../lookup/lkuSalesae";
import lkuCollector from "../lookup/lkuCollector";
import moment from "moment";
toastr.init();

export default {
  components: {
    lkuKoranCust,
    lkuKoranJurusan,
    lkuKoranKota,
    lkuSalesae,
    lkuCollector,
    vNumber,
    Loading
  },
  mixins: [validationMixin],
  validations: {
    model: {
      customer_id: { required },
      Bill2CustId: { required },
      jurusan_id: { required },
      kota_id: { required },
      // salesae_id: { required },
      // collector_id: { required },
      kiriman_code: { required },
      // isactive: { required },
      tanggal: { required },
      // isContractBase: { required },
      // gratis: {
      //   required: function() {
      //     if (this.model.gratis) {
      //       return true;
      //     } else if (this.model.eceran) {
      //       return true;
      //     } else return false;
      //   }
      // },
      eceran: {
        required: function() {
          if (this.model.eceran) {
            return true;
          } else if (this.model.gratis) {
            return true;
          } else return false;
        }
      },
      // hrg_langganan: { required },
      hrg_agen_ecer: { required },
      // hrg_agen_konsi: { required },
      DeliveryAddr: { required }
      // max_retur: { required }
    }
  },
  data() {
    return {
      inputBerlanjut:1,
      isEdit: false,
      isLoading: true,
      saveEnabled: true,
      // tglaktif: moment().subtract(5,'days').format('YYYY-MM-DD'),
      tglaktif: this.$store.state.user.tglkoran,
      uanguser: this.$store.state.user.matauang,
      lkuKoranCustShow: false,
      lkuKoranBill2CustShow: false,
      lkuKoranJurusanShow: false,
      lkuKoranKotaShow: false,
      lkuKoranSalesShow: false,
      lkuKoranColectorShow: false,
      lkuKoranAgenShow: false,
      koranagngroup: "KORANAGEN",
      isKORANAGEN:false,
      model: {
        customer_id: null,
        Bill2CustId: null,
        Bill2CustInfo: null,
        kiriman_code: null,
        jurusan_id: null,
        salesae_id: null,
        salesae_name: null,
        DeliveryAddr: null,
        kota_id: null,
        collector_id: null,
        collector_name: null,
        tanggal: moment(new Date()).format("YYYY-MM-DD"),
        DeliveryAddr: '',
        titikdrop: "",
        hrg_langganan: 0,
        hrg_agen_ecer: 0,
        hrg_agen_konsi: 0,
        eceran: 0,
        konsi: 0,
        langganan: 0,
        gratis: 0,
        perkenalan: 0,
        titipan: 0
      },
      isContractBase: 0,
      optionsContractBase: [
        { text: "Seterusnya (Tanpa Kontrak)", value: 0 },
        { text: "Sesuai Kontrak", value: 1 }
      ],
      customer: {},
      customerGroups: [],
      taxBussinesGroups: [],
      jeniskiriman: [],
      mode: "single",
      formats: {
        dayPopover: "WWW, MMM D, YYYY"
      },
      tanggal: new Date(),
      tgltutup: null,
    };
  },
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      // console.log(this.$v.model.$touch());
      return this.$v.model.$invalid;
    },
  },
  watch: {
    "model.eceran": function(val) {
      if (val) {
        this.model.totkirim=parseInt(val)+parseInt(this.model.langganan || 0)+parseInt(this.model.gratis || 0)+parseInt(this.model.titipan || 0);
      }
    },
    "model.langganan": function(val) {
      if (val) {
        this.model.totkirim=parseInt(val)+parseInt(this.model.eceran || 0)+parseInt(this.model.gratis || 0)+parseInt(this.model.titipan || 0);
      }
    },
    tanggal(val) {
      if (val !== null) {
        this.model.tanggal = moment(new Date(val)).format("YYYY-MM-DD");
      }
    },
    DeliveryAddr(val){
      this.model.DeliveryAddr = val;
    }
  },
  created: async function() {
    const a = await crud.list({ tablename: "koranjeniskiriman", limit: 1000 });
    this.jeniskiriman = a.reduce((newArr = [], el, idx) => {
      newArr.push({ value: el.kiriman_code, text: el.kiriman_name });
      return newArr;
    }, []);

    if (this.$route.params.kirimanKey) {
      this.isEdit = true;
      this.isLoading = true;
      const detail = await koran_kiriman.detail(this.$route.params);
      detail.tanggal = moment(detail.tanggal).format("YYYY-MM-DD");
      if (detail.tanggal<this.tglaktif) {
              this.saveEnabled=false;      
      }
      this.model = detail;
      this.model.CustInfo = `${detail.CustCode} | ${detail.CustName}`;
      // this.model.Bill2CustInfo = detail.Bill2CustNo;
      this.model.jurusan_info = detail.jurusan_code + " | " + detail.jurusan_name;
      this.isKORANAGEN = (this.model.customer_group || '').includes('KORANAGEN');

      this.isLoading = false;
    }
    this.isLoading = false;
  },
  methods: {
    changeTouchModal() {
      // console.log("changeTouchModal");
      this.$v.model.$touch();
    },
    changeJnsKiriman() {
      if (this.model.kiriman_code === "LANGGANAN") {
        this.model.max_retur = 0;
      }
    },
    changeDate(props, event) {
      // console.log("props", props);
      // console.log("event", event);
    },
    onSelectKoranAgen(_selected) {
      if (this.model.customer_id === _selected.customer_id) {
            toastr.error("Pilih Customer yang berbeda dg Agen untuk dititipkan.");
      } else {
          this.model.namaAgentDititip = `${_selected.CustName} | ${_selected.CustCode}`;
          this.model.kirimtitipke = _selected.customer_id;
          this.lkuKoranAgenShow = false;
      }
    },
    onSelectSalese: async function(_sales) {
      this.model.salesae_id = _sales.salesae_id;
      this.model.salesae_name = `${_sales.crewname || _sales.salesae_name}`;
      this.lkuKoranSalesShow = false;
    },
    onSelectCollector: async function(_collec) {
      this.model.collector_id = _collec.collector_id;
      this.model.collector_name = `${_collec.crewname}`;
      this.lkuKoranColectorShow = false;
    },
    onSelectKoranCust: async function(_selected) {
      // this.clearModel();
      if (this.model.kirimtitipke === _selected.customer_id) {
            toastr.error("Pilih Customer yang berbeda dg Agen untuk dititipkan.");
      } else {
        this.lkuKoranCustShow = false;
        // const deleveryAddr = `${(_selected.Address1 || "").trim()} ${(
        //   _selected.Address2 || ""
        // ).trim()} ${(_selected.City || "").trim()}`;
        // const resp = await koran_pesanan_permanen.detail(_selected);
        // const detail = resp[0];
        // if (detail) {
        //   detail.tanggal = moment(detail.tanggal).format("YYYY-MM-DD");
        //   this.isLoading = true;
        //     for (var key in detail) {
        //         this.model[key] = detail[key];
        //     }
        //   if (detail.DeliveryAddr === null) {
        //     this.model.DeliveryAddr = deleveryAddr;
        //   } else {
        //     this.model.DeliveryAddr = detail.DeliveryAddr;
        //   }
        //   this.model.Bill2CustInfo = `${detail.Bill2CustCode} | ${detail.Bill2CustName}`;
        //   this.model.jurusan_info = detail.jurusan_code + " | " + detail.jurusan_name;

        // } else {
        //   this.tanggal = new Date();
          this.model.tanggal === moment(new Date()).format("YYYY-MM-DD");          
          if (_selected.DeliveryAddr) {
            this.model.address = _selected.DeliveryAddr;
          } else {
            this.model.address = `${_selected.Address1} ${
              _selected.Address2 !== null ? _selected.Address2 : ""
                } ${_selected.City}`;
          }


          this.model.customer_id = _selected.customer_id;
          this.model.CustCode = _selected.CustCode;
          this.model.CustInfo = `${_selected.CustCode} | ${_selected.CustName}`;
          this.model.customer_group = _selected.customer_group;
          this.isKORANAGEN = (this.model.customer_group || '').includes('KORANAGEN');
          this.customer = _selected;

        if (_selected.Bill2CustId){
          this.model.Bill2CustId = `${_selected.Bill2CustId}`;
          this.model.Bill2CustInfo = `${_selected.Bill2CustNo} | ${_selected.Bill2CustName}`;
          this.model.bill2group = _selected.bill2group;
        } else {
          this.model.Bill2CustId = `${_selected.customer_id}`;
          this.model.Bill2CustInfo = `${_selected.CustCode} | ${_selected.CustName}`;
        }

        if (!(this.model.salesae_id)) {
          this.model.salesae_id = _selected.salesae_id;
          this.model.salesae_name = _selected.salesae_name;
        }
        if (!(this.model.kota_id)) {
          this.model.kota_id = _selected.kota_id;
          this.model.kota_name = _selected.kota_name;
        }
        if (!(this.model.jurusan_id)) {
          this.model.jurusan_id = _selected.jurusan_id;
          this.model.jurusan_name = _selected.jurusan_name;
          this.model.jurusan_info = _selected.jurusan_code + " | " + _selected.jurusan_name;
        }
        if (!(this.model.titikdrop)) {
          this.model.titikdrop = _selected.titikdrop;
        }

        // }
        // this.isLoading = false;
      }
    },
    onSelectKoranBill2Cust: function(_selected) {
      if (_selected.customer_id) {
        this.model.Bill2CustId = _selected.customer_id;
        this.model.Bill2CustInfo = `${_selected.CustCode} | ${_selected.CustName}`;
      }
      this.lkuKoranBill2CustShow = false;
    },
    onSelectKoranJurusan: async function(_selected) {
      this.model.jurusan_id = _selected.jurusan_id;
      this.model.ekspedisi_id = _selected.ekspedisi_id;
      this.model.jurusan_name = _selected.jurusan_name;
      this.model.jurusan_info = _selected.jurusan_code + " | " + _selected.jurusan_name;
      this.lkuKoranJurusanShow = false;
    },
    onSelectKoranKota: async function(_selected) {
      this.model.kota_id = _selected.kota_id;
      this.model.kota_name = _selected.kota_name;
      this.model.hrg_langganan = _selected.hrg_langganan;
      this.model.hrg_agen_ecer = _selected.hrg_agen_ecer;
      this.model.hrg_agen_konsi = _selected.hrg_agen_konsi;
      if (_selected.salesae_id){
         if (!(this.model.salesae_id)) {
          this.model.salesae_id = _selected.salesae_id;
          this.model.salesae_name = `${_selected.crewname || _selected.salesae_name}`;
         }          
      }
      this.lkuKoranKotaShow = false;
    },
    save: async function() {
      this.isLoading=true;
      if (this.invalidModel) {
        const invalidobj={};
        for (var key in this.$v.model) {
          if (this.$v.model[key].$anyError) {
             if (this.$v.model[key].$anyError==true) invalidobj[key] = this.$v.model[key];
          }
        }        
        console.log('validation model: ', this.model);
        console.log('validation field: ', invalidobj);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
        this.isLoading=false;        
      } else if (moment(this.model.tanggal).format("YYYY-MM-DD")<this.tglaktif) {
              toastr.error("Tanggal transaksi sudah CLOSED", "ERROR MESSAGE",10000);
              this.isLoading=false;        
      } else {
        try {
          // this.model.isContractBase = this.isContractBase;
          // this.model.DeliveryAddr= this.model.DeliveryAddr || '';
          const detail = JSON.parse(JSON.stringify(this.model));
          detail.tanggal = moment(this.model.tanggal).format("YYYY-MM-DD");
          // await koran_kiriman.save(this.model);
          await koran_kiriman.save(detail);

          this.isLoading=false;
          toastr.success("Save successfully",'Form Kiriman koran',10000);
          if (this.inputBerlanjut==0){
              this.close();
          } else {
              this.saveEnabled=true;      
              this.model.eceran = 0;
              this.model.gratis = 0;
              this.model.langganan = 0;
              this.model.konsi = 0;
              this.model.titipan = 0;
              this.model.totkirim = 0;
              const keys = ['tanggal','kiriman_code','eceran', 'langganan','gratis','titipan', 'konsi','totkirim' ];                                        
              for (var key in this.model) {
                  if (keys.indexOf(key) == -1) {
                      this.model[key] = '';
                  }
              }
              this.$v.model.$reset();                        
          }
        } catch (error) {
                this.isLoading=false;
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
        }
      }
    },
    close() {
      if ((this.$store.state.prevRoute.name) && (this.$route.name !==this.$store.state.prevRoute.name)) {
        router.push({name:this.$store.state.prevRoute.name});
      } else {
        router.push({ name: "koran.kiriman" });
      }

    },
    clearModel() {
      this.model = {
        customer_id: null,
        kiriman_code: null,
        jurusan_id: null,
        salesae_id: null,
        salesae_name: null,
        DeliveryAddr: null,
        kota_id: null,
        collector_id: null,
        collector_name: null,
        isactive: 1,
        hrg_langganan: 0,
        hrg_agen_ecer: 0,
        hrg_agen_konsi: 0,
        langganan: 0,
        eceran: 0,
        konsi: 0,
        gratis: 0,
        titipan: 0,
        totkirim: 0,
      };

      this.tanggal = new Date();
    }
  }
};
</script>